// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"490e24ae","359":"325ffda2","382":"23ebd769","415":"93bd546a","439":"58384b89","622":"1c6bcc6c","626":"d0f00370","742":"10511f61","787":"4d3171fe","895":"10e21931"}[chunkId] + ".chunk.js";
};